<!--Start Back To Top Button--> 
<a href="javaScript:;" class="back-to-top"><i class="fa fa-angle-double-up"></i> </a>
<!--End Back To Top Button-->
<!--Start footer-->
<footer class="footer">
	<div class="container">
		<div class="text-center">Copyright © 2025 
			<a   class="company_link text-primary" target="" rel="noopener">SSC Trash Handler</a>
		</div>
	</div>
</footer>
<!--End footer-->